// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type { IBuyPackageRequest, TBuyPackageModel, IMappers, TBuyPackageResponse, IBuyPackageResponse } from './types';

export const defaultConfig: TBuyPackageModel = {
  apiType: 'public',
  assertStatusCodes: [200],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'billing-service-packages-balancer',
  pathApi: '/v2/buy-package/',
  requestType: 'json',
  responseType: 'json',
} as TBuyPackageModel;

export function createBuyPackageModel(parameters: IBuyPackageRequest): TBuyPackageModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IBuyPackageOptions<TResponse200> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
  parameters: IBuyPackageRequest;
}

export async function fetchBuyPackage<TResponse200>({
  httpApi,
  config,
  mappers,
  parameters,
}: IBuyPackageOptions<TResponse200>): Promise<TBuyPackageResponse | TResponse200> {
  const { statusCode, response, headers } = await httpApi.fetch(createBuyPackageModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IBuyPackageResponse);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TBuyPackageResponse;
}
